import ConfigContext from 'src/context/config';
import useNonNullContext from 'src/hooks/useNonNullContext';

export const GTMAnalytics: React.FC = () => {
  const configContext = useNonNullContext(ConfigContext);
  const gtmTagValue = configContext.clientSideKeys.gtmKey;
  return gtmTagValue ? (
    <script
      dangerouslySetInnerHTML={{
        __html: `
                // Init GTM after 3.5 seconds, unless the user has performed a mouse/touch event
                // If the user has interacted with the page, load GTM immediately
                document.addEventListener('DOMContentLoaded', () => {
                  setTimeout(initGTM, 3500);
                });
                document.addEventListener('scroll', initGTMOnEvent);
                document.addEventListener('mousemove', initGTMOnEvent);
                document.addEventListener('touchstart', initGTMOnEvent);

                function initGTMOnEvent (event) {
                  initGTM();
                  event.currentTarget.removeEventListener(event.type, initGTMOnEvent); // remove the event listener that got triggered
                }

                function initGTM () {
                  if (window.gtmDidInit) {
                    return false;
                  }
                  window.gtmDidInit = true; // flag to ensure script does not get added to DOM more than once.
                  const script = document.createElement('script');
                  script.type = 'text/javascript';
                  script.async = true;
                  script.onload = () => { dataLayer.push({ event: 'gtm.js', 'gtm.start': (new Date()).getTime(), 'gtm.uniqueEventId': 0 }); } // this part ensures PageViews is always tracked
                  script.src = '/static/js/gtm.js';
                  script.gtmTagValue = '${gtmTagValue}'

                  document.head.appendChild(script);
                }
              `,
      }}
    />
  ) : null;
};
